import { cx } from '@emotion/css';
import { useRef } from 'react';

import {
  Button,
  ButtonTypes,
  Logo,
  Transition,
} from 'apps/shared/scripts/components';

import {
  actionClassName,
  bodyClassName,
  btnPrimaryClassName,
  btnPrimaryDisabledClassName,
  btnSecondaryClassName,
  btnSecondaryDisabledClassName,
  containerClassName,
  headerClassName,
  innerClassName,
  savebarClassName,
  wrapperClassName,
} from './styles';

interface Props {
  onDiscard: () => void;
  onSave: () => void;
  isEditMode?: boolean;
  isLoading?: boolean;
  isSuccess?: boolean;
  isVisible: boolean;
}

const Savebar = ({
  onDiscard,
  onSave,
  isEditMode,
  isLoading,
  isSuccess,
  isVisible,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const isDisabled = isLoading || isSuccess;

  return (
    <Transition isVisible={isVisible} nodeRef={ref}>
      <nav id="savebar" className={savebarClassName} ref={ref}>
        <div className={innerClassName}>
          <div className={headerClassName}>
            <Logo light />
          </div>
          <div className={bodyClassName}>
            <div className={containerClassName}>
              <div className={wrapperClassName}>
                <div className={actionClassName}>
                  <Button
                    className={cx(btnSecondaryClassName, {
                      [btnSecondaryDisabledClassName]: isDisabled,
                    })}
                    disabled={isDisabled}
                    onClick={onDiscard}
                    type={ButtonTypes.Button}
                  >
                    Discard
                  </Button>
                  <Button
                    className={cx(btnPrimaryClassName, {
                      [btnPrimaryDisabledClassName]: isDisabled,
                    })}
                    disabled={isDisabled}
                    loading={isLoading}
                    onClick={onSave}
                    success={isSuccess}
                    type={ButtonTypes.Submit}
                  >
                    {isEditMode ? 'Save' : 'Create'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </Transition>
  );
};

Savebar.displayName = 'Savebar';

export default Savebar;
